<style scoped>
.blue-tip {
  color: #638ca6;
  font-size: 14px;
  margin: 0 5px;
}
</style>

<template lang="pug">
.report 
  PageTitle(
    pagetitle="浏览网站",
    tip="掌握您网站访客还浏览了行业内哪些其他网站，离开您网站的访客去了行业内哪些其他网站，帮助您发现潜在竞争，及时调整营销策略")

  div.time
    TimeSpan(
      filters="7a",
      @change="onTimespanChange")
    p 分析网站：
      a.blue-tip(
        :href="currentDomain.domain",
        target="_blank"
      ) {{currentDomain.domainTitle}}
      | 所在行业： 
      i.blue-tip {{currentDomain.industry_1_name}}
      v-tooltip(
        :tip="'该行业分类为站点设置时选择的，如需修改请进入设置中心-站点管理中进行修改'",
        pos="right"
      )
        i.fa.fa-question-circle

  .zone
    TableTitle(icon="fa fa-signal" title="趋势图")

    LineChart(
      v-bind:legend="legend",
      v-bind:xAxis="chartXAxis",
      v-bind:series="chartSeries")

  .zone
    TableTitle(icon="fa fa-list", :title="tableTabTitle")
    div.nav-tabs
      TabContent(
        title="主维度：",
        v-bind:tablist="tablist",
        v-bind:update="updateTab")
        DownloadBtn(
          slot="extentTab",
          v-bind:reportApi="reportApi",
          v-bind:params="query",
          :pagetitle="tableTabTitle",
          subtitle="",
          v-if="total > 0")
        div(slot="relatedomain") 
          p.tabAction
            button.btn.btn-primary.btn-big(
              v-bind:disabled="fetchLineChartabled",
              @click="fetchLineChartData"
            ) 绘制选定行
          p 浏览了 
            a.blue-tip(
              :href="currentDomain.domain",
              target="_blank"
            ) {{currentDomain.domainTitle}}
            | 的访客还浏览了
            i.blue-tip {{currentDomain.industry_1_name}} 
            | 行业的以下网站，展示 TOP20 网站
        div(slot="godomain") 
          p.tabAction
            button.btn.btn-primary.btn-big(
              v-bind:disabled="fetchLineChartabled",
              @click="fetchLineChartData"
            ) 绘制选定行
          p 离开 
            a.blue-tip(
              :href="currentDomain.domain",
              target="_blank"
            ) {{currentDomain.domainTitle}}
            | 网站去向
            i.blue-tip {{currentDomain.industry_1_name}} 
            | 行业的以下网站，展示 TOP20 网站


    complex-table(
      :classname="'data-table'",
      :columns="columns",
      :list="tableDataList",
      :sum="{}",
      :checkbox="hasCheckBox",
      :checkbox_length="checkboxLength")

      v-tooltip(
        slot="uvrate",
        :tip="'访客渗透=浏览了自己网站的访客还浏览A网站的访客数/浏览自己网站的访客数'",
        pos="left")
        i.fa.fa-question-circle(style="margin-left: 5px;")

    v-pagination(
      :total="total",
      v-bind:pn="pg",
      v-bind:ps="ps",
      v-if="total > ps",
      @updatepage="getTableData")
</template>

<script>
  import Vue from 'vue'
  import Store from '../../store/store.js'
  import Table from '../../component/complex-table.vue'
  import Mixin from '../mixin.js'
  export default {
    store: Store,
    mixins: [Mixin],
    components: {
      'complex-table': Table
    },
    data() {
      return {
        currentDomain: {
          domain: '',
          domainTitle: '',
          industry_1_name: '',
          industry_1: ''
        },
        //用于画图
        twoIndiceSelectabled: true,
        hasCheckBox: true,
        checkboxLength: 3,
        chartResList: [],
        legend: [],
        chartXAxis: [],
        chartSeries: [],
        total: 0,
        pg: 1,
        ps: 10,
        currentTab: 'relatedomain',
        tablist: [
          {
            id: 'relatedomain', 
            name: '浏览网站', 
            reportTableApi:'/api/industrysite/sitereport?groupby=domain_relate',
            reportLineChartApi: '/api/industrysite/sitereport?groupby=domain_relate,date'
          },
          {
            id: 'godomain', 
            name: '去向网站', 
            reportTableApi:'/api/industrysite/sitereport?groupby=domain_relate',
            reportLineChartApi: '/api/industrysite/sitereport?groupby=domain_relate,date'
          }
        ],
        customIndice: "uvrate",
        tableDataList: [],
      }
    },
    computed: {
      columns() {
        let columns = [
          {
            title: '去向网站',
            key: 'name',
            render: this.textEllipsidRender
          },{
            title: '访客渗透',
            key: 'uvrate',
            render: this.percentRender
          }
        ]
        columns[0].title = _.find(this.tablist, {id: this.currentTab}).name
        return columns
      },
      tableTabTitle() {
        return _.find(this.tablist, {id: this.currentTab}).name + '报表'
      },
      domainId() {
        return this.$store.state.domainId
      },
      uiError() {
        return this.$store.state.uiError
      },
      fetchLineChartabled() {
        return this.$store.state.tableCheckList.length == 0 || !this.$store.state.drawChartabled
      },
      query() {
        let query = {
          cycle: this.$store.state.start == this.$store.state.end ? 'hour' : 'day',
          domainId: this.domainId,
          start: this.$store.state.start,
          end: this.$store.state.end,
          industry_1: this.currentDomain.industry_1,
          pvtype: 0,
          mdim: this.currentTab,
          timespan: new Date().getTime(),
        }
        return query
      },
      reportApi() {
        return _.find(this.tablist, {id: this.currentTab}).reportTableApi
      }
    },
    mounted() {
      this.getCurrentDomain()
    },
    watch: {
      domainId() {
        this.getCurrentDomain()
      },
      uiError() {
        this.$Modal.warn(this.uiError.errMsg)
      },
      currentDomain: {
        handler() {
          this.getTableData()
        },
        deep: true
      }
    },
    methods: {
      onTimespanChange({start, end}) {
        this.compareStart = start
        this.compareEnd = end
        if((new Date(end) - new Date(start)) > 365*24*3600*1000){
          return this.$Modal.warn(`您选择时间段超过了一年`)
        }
        this.getTableData()
      },
      updateTab(tab) {
        if(this.currentTab == tab) return
        this.currentTab = tab
        this.getTableData()
      },
      getTableData(pn=1) {
        this.pg = pn
        if(!this.currentDomain.industry_1 || !this.domainId) return
        this.total = 0
        this.$store.dispatch("SET_TABLE_LOADING", true)
        this.$store.dispatch("SET_TABLE_CHECKLIST", [])
        let params = _.cloneDeep(this.query)
        params.pg = this.pg
        params.ps = this.ps
        let reportPromise = this.$http.get(_.find(this.tablist, {id: this.currentTab}).reportTableApi, {params:params})
        this.$store.dispatch("VUE_HTTP", [reportPromise])
          .then((res) => {
              if(res){
                this.$store.dispatch("SET_TABLE_LOADING", false)
                let reportlist = this.addItemChecked(res.list)
                this.tableDataList = reportlist
                this.total = res.total
                if(reportlist.length > 0){
                  let checklist = _.concat([], reportlist[0])
                  this.$store.dispatch("SET_TABLE_CHECKLIST", checklist)
                  this.fetchLineChartData()
                }else{
                  //清空画图数据
                  this.legend = [] 
                  this.chartXAxis = []
                  this.chartSeries = []
                }

              }
          })
      },
      getCurrentDomain() {
        if(!this.domainId) return 

        let currentDomainPromise = this.$http.get(`/api/industrysite/domaininfo?cycle=hour&domainId=${this.domainId}&timespan=${new Date().getTime()}`)
        this.$store.dispatch("VUE_HTTP", [currentDomainPromise])
        .then((res) => {
          if(res) {
            if(res.list.length > 0){
              res.list[0].domain = 'http://' + res.list[0].domain
              this.currentDomain = res.list[0]
            }
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// sites.vue?f8f3280c